/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchnellauswahlDto } from '../../models/schnellauswahl-dto';

export interface GetSchnellauswahlById$Plain$Params {

/**
 * Id der Schnellauswahl nach der gesucht werden soll
 */
  schnellauswahlId: string;
}

export function getSchnellauswahlById$Plain(http: HttpClient, rootUrl: string, params: GetSchnellauswahlById$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SchnellauswahlDto>> {
  const rb = new RequestBuilder(rootUrl, getSchnellauswahlById$Plain.PATH, 'get');
  if (params) {
    rb.path('schnellauswahlId', params.schnellauswahlId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchnellauswahlDto>;
    })
  );
}

getSchnellauswahlById$Plain.PATH = '/v1/schnellauswahl/{schnellauswahlId}';
